import React from "react";
import { CustomLeftTitle } from "../../pages/ProfilePage/styles";
import { CustomTextField } from "../../pages/ProfilePage/styles";
import { FirstNameContainer } from "../../pages/ProfilePage/styles";
import { SocialMediaLinksFormProps } from "../../pages/ProfilePage/types";

export const SocialMediaLinksForm: React.FC<SocialMediaLinksFormProps> = ({
  links,
  setLinks,
  affiliation,
  setAffiliation,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLinks((prevLinks) => ({ ...prevLinks, [name]: value }));
  };

  return (
    <>
      <FirstNameContainer>
        <CustomLeftTitle>Website Link</CustomLeftTitle>
        <CustomTextField
          name="websiteLink"
          id="websiteLink-outlined-basic"
          value={links.websiteLink}
          variant="outlined"
          onChange={handleChange}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>Instagram Link</CustomLeftTitle>
        <CustomTextField
          name="instagramLink"
          id="instagramLink-outlined-basic"
          value={links.instagramLink}
          variant="outlined"
          onChange={handleChange}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>Spotify Link</CustomLeftTitle>
        <CustomTextField
          name="spotifyLink"
          id="spotifyLink-outlined-basic"
          value={links.spotifyLink}
          variant="outlined"
          onChange={handleChange}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>SoundCloud Link</CustomLeftTitle>
        <CustomTextField
          name="soundCloudLink"
          value={links.soundCloudLink}
          variant="outlined"
          onChange={handleChange}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>ASCAP ID</CustomLeftTitle>
        <CustomTextField
          value={affiliation?.ASCAP}
          variant="outlined"
          onChange={(e) => {
            const updatedValue = e.target.value;
            setAffiliation((prev) => ({
              ASCAP: updatedValue,
              BMI: prev?.BMI || "",
              SESCAP: prev?.SESCAP || "",
            }));
          }}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>BMI ID</CustomLeftTitle>
        <CustomTextField
          value={affiliation?.BMI}
          variant="outlined"
          onChange={(e) => {
            const updatedValue = e.target.value;
            setAffiliation((prev) => ({
              ASCAP: prev?.ASCAP || "",
              BMI: updatedValue,
              SESCAP: prev?.SESCAP || "",
            }));
          }}
        />
      </FirstNameContainer>
      <FirstNameContainer>
        <CustomLeftTitle>SESAC ID</CustomLeftTitle>
        <CustomTextField
          value={affiliation?.SESCAP}
          variant="outlined"
          onChange={(e) => {
            const updatedValue = e.target.value;
            setAffiliation((prev) => ({
              ASCAP: prev?.ASCAP || "",
              BMI: prev?.BMI || "",
              SESCAP: updatedValue,
            }));
          }}
        />
      </FirstNameContainer>
    </>
  );
};
